import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"
import { routeGuard, scrollBehavior } from "./helpers"
import Home from "../views/Home.vue"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/terms",
    name: "Terms",
    component: () => import(/* webpackChunkName: "terms" */ "../views/legal/Terms.vue"),
    meta: {
      head: {
        title: "Terms"
      }
    }
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import(/* webpackChunkName: "privacy" */ "../views/legal/Privacy.vue"),
    meta: {
      head: {
        title: "Privacy"
      }
    }
  },
  {
    path: "/disclaimer",
    name: "Disclaimer",
    component: () => import(/* webpackChunkName: "disclaimer" */ "../views/legal/Disclaimer.vue"),
    meta: {
      head: {
        title: "Disclaimer"
      }
    }
  },
  {
    path: "/check",
    name: "Check",
    component: () => import(/* webpackChunkName: "check" */ "../views/Check.vue"),
    meta: {
      head: {
        title: "Extension checking"
      }
    }
  },
  {
    path: "/signup",
    name: "Signup",
    component: () => import(/* webpackChunkName: "signup" */ "../views/account/Signup.vue"),
    meta: {
      authenticated: false,
      head: {
        title: "Sign up"
      }
    }
  },
  {
    path: "/signin",
    name: "Signin",
    component: () => import(/* webpackChunkName: "signin" */ "../views/account/Signin.vue"),
    meta: {
      authenticated: false,
      head: {
        title: "Sign in"
      }
    }
  },
  {
    path: "/auth/validate",
    name: "Validation",
    component: () => import(/* webpackChunkName: "authValidation" */ "../views/account/Validation.vue"),
    meta: {
      head: {
        title: "Account validation"
      }
    }
  },
  {
    path: "/auth/recovery",
    name: "AccountRecovery",
    component: () => import(/* webpackChunkName: "accountRecovery" */ "../views/account/Recovery.vue"),
    meta: {
      head: {
        title: "Account recovery"
      }
    }
  },
  {
    path: "/auth/recovery/reset",
    name: "AccountReset",
    component: () => import(/* webpackChunkName: "accountReset" */ "../views/account/Reset.vue"),
    meta: {
      head: {
        title: "Password reset"
      }
    }
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: () => import(/* webpackChunkName: "notifications" */ "../views/account/Notifications.vue"),
    meta: {
      authenticated: true,
      head: {
        title: "Notifications"
      }
    }
  },
  {
    path: "/account",
    name: "Account",
    component: () => import(/* webpackChunkName: "account" */ "../views/account/Account.vue"),
    meta: {
      authenticated: true,
      head: {
        title: "Account"
      }
    }
  },
  {
    path: "/groups",
    name: "Groups",
    component: () => import(/* webpackChunkName: "groups" */ "../views/groups/List.vue"),
    meta: {
      authenticated: true,
      head: {
        title: "Groups"
      }
    }
  },
  {
    path: "/group/:id",
    name: "Group",
    component: () => import(/* webpackChunkName: "group" */ "../views/groups/View.vue"),
    meta: {
      head: {
        title: "Group"
      }
    }
  },
  {
    path: "/i/:token",
    name: "Invitation",
    component: () => import(/* webpackChunkName: "invitation" */ "../views/groups/Invitation.vue"),
    meta: {
      head: {
        title: "Invitation"
      }
    }
  },
  {
    path: "/message/new/:gid?",
    name: "NewMessage",
    component: () => import(/* webpackChunkName: "newMessage" */ "../views/messages/New.vue"),
    meta: {
      authenticated: true,
      head: {
        title: "New message"
      }
    }
  },
  {
    path: "/messages",
    name: "Messages",
    component: () => import(/* webpackChunkName: "messages" */ "../views/messages/List.vue"),
    meta: {
      authenticated: true,
      head: {
        title: "My messages"
      }
    }
  },
  {
    path: "/messages/lookup",
    name: "MessageLookup",
    component: () => import(/* webpackChunkName: "messageLookup" */ "../views/messages/Search.vue"),
    meta: {
      head: {
        title: "Find a message"
      }
    }
  },
  {
    path: "/m",
    name: "Message",
    component: () => import(/* webpackChunkName: "message" */ "../views/messages/View.vue"),
    meta: {
      head: {
        title: "Message"
      }
    }
  },
  {
    path: "/:pathMatch(.*)",
    name: "404",
    component: () => import(/* webpackChunkName: "404" */ "../views/errors/404.vue"),
    meta: {
      head: {
        title: "Not found"
      }
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior
})

router.beforeEach(routeGuard)

export default router
